import {Environment} from "../Client/Models/environment";

export const environment: Environment = {
  applicationUrl: "https://timerecorder.kibag.ch/",
  webApiUrl: "https://timerecorder.kibag.ch/api",
  downloadUrl: "https://apps.mlink.kibag.ch/prod/time",
  targetServerVersion: "2.0.22",
  isTest: false,
  backButton: false,
  version: "2.0.22",
  updateCheckInterval: 5 * 60 * 1000,
  showInstallModal: false,
};
